import React, { useMemo } from 'react';

import mdToHtml from 'utils/md-to-html';

import Html from './Html';

interface Props {
    safe?: boolean;
    text: string;
    style?: React.CSSProperties;
    className?: string;
}

const MarkdownElement: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
    { safe = true, text, style, className },
    ref
) => {
    const html = useMemo(() => mdToHtml(text, { safe }), [safe, text]);
    return <Html html={html} className={className} style={style} ref={ref} />;
};

export default React.forwardRef(MarkdownElement);
